import { render, staticRenderFns } from "./EmailModule.vue?vue&type=template&id=00cbb5fd&scoped=true&"
import script from "./EmailModule.vue?vue&type=script&lang=js&"
export * from "./EmailModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cbb5fd",
  null
  
)

export default component.exports